import { render, staticRenderFns } from "./EditSocialModal.vue?vue&type=template&id=152be4f9&scoped=true&%23default=%7B%7D&"
import script from "./EditSocialModal.vue?vue&type=script&lang=js&"
export * from "./EditSocialModal.vue?vue&type=script&lang=js&"
import style0 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&lang=css&"
import style1 from "./EditSocialModal.vue?vue&type=style&index=1&id=152be4f9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "152be4f9",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/www/uat.cabcom.dashtogo.com/laravel/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('152be4f9')) {
      api.createRecord('152be4f9', component.options)
    } else {
      api.reload('152be4f9', component.options)
    }
    module.hot.accept("./EditSocialModal.vue?vue&type=template&id=152be4f9&scoped=true&%23default=%7B%7D&", function () {
      api.rerender('152be4f9', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/csmworkflow/js/components/deliverables/EditSocialModal.vue"
export default component.exports